import * as React from 'react';
import { Link } from 'react-router';

export type Props = {
  to: string;
  children?: React.ReactNode;
};

export const NavigationLink = (props: Props) => <Link {...props} />;
